import { AppContext } from '../schema/AppContext';

/**
 * Method to create a new app context for a workflow.
 */
export function createAppContext(): AppContext {
    return new AppContext();
}
